import axios from './_nestAxios'

// Consultar logic

export const obtenerAsInfoAsignacion = params =>
  axios.get('/presupuestos-asignaciones', { params: { tipoConsulta: 'info-asignaciones', ...params } })

// Insertar-actualizar logic

export const nuevoActualizar = data => axios.post('/presupuestos-asignaciones', data)

// Reporte logic

export const descargarReporteAsignacion = params =>
  axios.get('/presupuestos-asignaciones/descargar/reporte-asignacion', { responseType: 'blob', params })
